import { render, staticRenderFns } from "./OriginalAuthor.vue?vue&type=template&id=b3542e34&scoped=true"
import script from "./OriginalAuthor.vue?vue&type=script&lang=js"
export * from "./OriginalAuthor.vue?vue&type=script&lang=js"
import style0 from "./OriginalAuthor.vue?vue&type=style&index=0&id=b3542e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3542e34",
  null
  
)

export default component.exports